import { TextStyle } from "./common";
const baseHeadingData = { level: 0 };
const HeadingData = {
  fromJSON(object) {
    const message = { ...baseHeadingData };
    message.level = object.level !== void 0 && object.level !== null ? Number(object.level) : 0;
    message.textStyle = object.textStyle !== void 0 && object.textStyle !== null ? TextStyle.fromJSON(object.textStyle) : void 0;
    message.indentation = object.indentation !== void 0 && object.indentation !== null ? Number(object.indentation) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.level !== void 0 && (obj.level = Math.round(message.level));
    message.textStyle !== void 0 && (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : void 0);
    message.indentation !== void 0 && (obj.indentation = message.indentation);
    return obj;
  }
};
export {
  HeadingData
};
//# sourceMappingURL=node_heading.js.map
